import { render, staticRenderFns } from "./ScopeSelectorScope.vue?vue&type=template&id=382d08cc&scoped=true&"
import script from "./ScopeSelectorScope.vue?vue&type=script&lang=ts&"
export * from "./ScopeSelectorScope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382d08cc",
  null
  
)

export default component.exports